import { Button, Divider, message, Space, Table, Typography } from "antd";
import moment from "moment-timezone";
import React, { useState } from "react";

import { pluralize, writeSharedReadable } from "../../utils/Utils";
import ListMSEmail from "./ListMultiSelectOptions/ListMSEmail";
import { apiCall } from "../../utils/Api";

export default function ListMultiSelect(props) {

    const { 
        catalogues = [],
        close = () => { }, 
        sel = [], 
        my_company = false,
        getCatalogues = () => {}
    } = props;

    const [loading, setLoading] = useState(false);
    const [saveButtonText, setSaveButtonText] = useState("");
    const [apiCallText, setApiCallText] = useState();
    const [apiArgs, setApiArgs] = useState();
    const listIds = sel.map(item => item.list_id);

    const trashAll = (sel) => {
        apiCall("titlelist/trashMultiple", { list_ids: JSON.stringify(listIds), is_picked: true }, (_status, _result) => {
            if (_status) {
                message.success("All selected catalogues have been moved to trash.");
                getCatalogues();
                close();
            }
        })
    }

    const favAll = () => {
        apiCall("titlelist/starMultiple", { list_ids: JSON.stringify(listIds), is_picked: true }, (_status, _result) => {
            if (_status) {
                message.success("All selected catalogues have been favorited.");
                getCatalogues();
                close();
            }
        })
    }

    const archiveAll = (sel) => {
        apiCall("titlelist/archiveMultiple", { list_ids: JSON.stringify(listIds), is_picked: true }, (_status, _result) => {
            if (_status) {
                message.success("All selected catalogues have been archived.");
                getCatalogues();
                close();
            }
        })
    }

    const columns = [
        {
            title: "Name", dataIndex: 'name', key: 'name'
        },
        {
            title: "Total Titles", dataIndex: 'isbns_count', key: 'isbns_count'
        },
        {
            title: "Shared Status", dataIndex: 'shared_status', key: 'shared_status', render: (e, f) => {
                return (
                    <small style={{"textAlign" : "center"}}>
                        {writeSharedReadable(f.shared_status)}
                    </small>
                )
            }
        },
        {
            title: "Last Updated", dataIndex: 'date_updated', key: 'date_updated', render: (e, f) => {
                return (
                    <>
                        <div><nobr>{moment(e * 1000).format("MMMDD-YY")}</nobr></div>
                    </>
                )
            }
        }
    ];

    return (
        <>
            <div style={{ "padding": "20px" }}>
                <div>
                    <Typography.Title level={5}>{sel.length} {pluralize(sel.length, "Catalogue", "s")} Selected</Typography.Title>
                    <Divider />
                    <Table
                        size="small"
                        pagination={false}
                        scroll={{ y: 250 }}
                        bordered
                        dataSource={catalogues}
                        columns={columns}>
                    </Table>
                    <ListMSEmail
                        setApiArgs={setApiArgs}
                        setApiCallText={setApiCallText}
                        sel={sel}
                        catalogues = {catalogues}
                        setSaveButtonText={setSaveButtonText}
                    />
                    
                </div>
                
                <div style={{ "float": "left" }}>
                    {
                        my_company ? 
                            <Space>
                                <Button type="danger" onClick={() => close()}>Cancel</Button>
                            </Space> : 
                            <Space>
                                <Button type="danger" onClick={() => trashAll(sel)}>Trash All ({sel.length})</Button>
                                <Button type="primary" onClick={() => favAll(sel)}>Fav All ({sel.length})</Button>
                                <Button type="primary" onClick={() => archiveAll(sel)}>Archive All ({sel.length})</Button>
                            </Space>
                    }

                </div>                
                <br clear="all" />
            </div>
        </>
    )
}